import styles from './styles.module.scss';
import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { tabLinks } from './constants';
import classNames from 'classnames';

const TabList = ({
  className
}) => {
  const {
    pathname
  } = useLocation();
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.container, className)
  }, tabLinks.map(tab => /*#__PURE__*/React.createElement(Link, {
    key: tab.id,
    className: classNames(styles.link, styles.item, tab.id === pathname ? styles.active : null),
    to: tab.id
  }, /*#__PURE__*/React.createElement("span", null, tab.label))));
};

export default TabList;